export interface ILiveBlogState {
  liveEvents: LiveEvent[];
  sortBy: LiveBlogSorting;
  totalEvents: number;
  pageNum: number;
  timeFilter: LiveBlogFilter;
  isLoading: boolean;
}

export interface LiveEvent {
  id: string;
  eventCode: string;
  title: string;
  location: string;
  url: string;
  reporterIds: string[];
  // indicates this specific event data
  // was fetched from the server.
  isFetched: boolean;
  end: LiveEventTime;
  start: LiveEventTime;
  timeZone: string;
  // isEmbedded deprecates lastSeen property.
  isEmbedded: boolean;
  // Creation time of live blog
  createdAt: number;
}

export enum LiveBlogModalMode {
  Create = 'create',
  Edit = 'edit',
  Duplicate = 'duplicate'
}

export enum LiveBlogModalView {
  EventDetails = 'event details',
  Team = 'reporters',
  EmbedCode = 'embed code'
}

export enum LiveBlogSorting {
  StartingTime = 'starting_time',
  EndingTime = 'ending_time',
  UpdateTime = 'updating_time'
}

export enum LiveBlogFilter {
  Upcoming = 'upcoming',
  Live = 'live',
  Past = 'past',
  All = 'all'
}

export interface LiveEventTime {
  date: number;
  hour: number;
  minute: number;
  time: number;
}
